import ParkingHistory from "../../components/ParkingHistory";

const ParkingHistoryListPage = () => {
  return <ParkingHistory />;
};

export default ParkingHistoryListPage;